// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DescriptionsTokens } from './type';

const descriptionsTokens: DescriptionsTokens = {
  descriptionsTitlePaddingBottom: 'Padding-12',
  descriptionsLabelPaddingBottom: 'Padding-12',
  descriptionsLabelPaddingRight: 'Padding-8',
  descriptionsValuePaddingBottom: 'Padding-12',
  descriptionsTitleSmallSize: '14/medium',
  descriptionsTitleDefaultSize: '16/medium',
  descriptionsTitleLargeSize: '18/medium',
  descriptionsBorderDefaultSize: '1px',
  descriptionsFontSmallSize: '12/regular',
  descriptionsFontDefaultSize: '14/regular',
  descriptionsFontLargeSize: '16/regular',
  descriptionsLabelColor: 'Neutral-text-4',
  descriptionsValueColor: 'Neutral-text-5',
  descriptionsTitleColor: 'Neutral-text-5',
  descriptionsBackgroundColor: 'Neutral-fill-2',
  descriptionsBorderColor: 'Neutral-border-1',
  descriptionsTitleFontWeight: '500',
  descriptionsTitleGap: 'Size-2',
  descriptionsBorderRadius: 'Size-2',
  descriptionsBorderRightSize: '1px',
  descriptionsBorderBottomSize: '1px',
  descriptionsBorderPaddingX: 'Padding-8',
  descriptionsBorderPaddingY: 'Padding-12',
  descriptionsInlineBorderPaddingX: 'Padding-8',
  descriptionsInlineBorderPaddingY: 'Padding-12',
};

export default descriptionsTokens;
